import React from "react";
import CourseLockedBottomSheet from "../CourseLockedBottomSheet/CourseLockedBottomSheet";
import * as actionCreator from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { initialisePaymentService } from "@src/PaymentService";
import { safeJsonParse } from "@src/utils/safeJsonParse";

const LikeWhatYouAreWatchingBottomSheet = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showWhatAreYouWatchingBottomSheet
  );
  const item = safeJsonParse(localStorage.getItem("currentItem"), {
    source: "LikeWhatYouAreWatchingBottomSheet [localStorage.currentItem]",
    fallback: {},
  });
  let isPurchased = item?.isPurchased;

  return (
    <CourseLockedBottomSheet
      mainText={t(
        "components.bottomSheets.components.likeWhatAreYourWatchingBottomSheet.LikeWhatYouAreWatching",
        "Like what you are watching?"
      )}
      subText={t(
        "components.bottomSheets.components.likeWhatAreYourWatchingBottomSheet.limitedPeriodOver",
        "Your 2 minutes of limted preview is over. To get access to all course contents and continue with your learning seamlessly."
      )}
      btnText={t(
        "components.bottomSheets.components.likeWhatAreYourWatchingBottomSheet.buyNow",
        "Buy now"
      )}
      btnAction={() => {
        dispatch(actionCreator.showWhatAreYouWatchingBottomSheetAction(false));
        initialisePaymentService();
      }}
      viewAllSubText={
        !isPurchased
          ? t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBackInstead",
              "Go back instead"
            )
          : t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBack",
              "Go back"
            )
      }
      state={state}
      dispatcher={() =>
        dispatch(actionCreator.showWhatAreYouWatchingBottomSheetAction(false))
      }
      showBtn={!isPurchased}
    />
  );
};

export default LikeWhatYouAreWatchingBottomSheet;
